import { render } from "./UploadFormat.vue?vue&type=template&id=73634bee&scoped=true"
import script from "./UploadFormat.vue?vue&type=script&lang=js"
export * from "./UploadFormat.vue?vue&type=script&lang=js"

import "./UploadFormat.vue?vue&type=style&index=0&id=73634bee&scoped=true&lang=css"
import "./UploadFormat.vue?vue&type=style&index=1&id=73634bee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73634bee"]])

export default __exports__